// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"48":"8c559ac7e3321334bad7","764":"2648b01e37adc06e5fb5"}[chunkId] + ".js";
};